// src/components/servicepartner/ServicePartnerRatesForm.jsx
import { Text, Input, VStack, HStack } from "@chakra-ui/react";

export default function ServicePartnerRatesForm({ partnerRates, setPartnerRates }) {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setPartnerRates((prev) => ({ ...prev, [name]: value }));
  };

  const rows = [
    { type: "meister", label: "Meister" },
    { type: "techniker", label: "Techniker" },
    { type: "ingenieur", label: "Ingenieure" },
    { type: "facharbeiter", label: "Facharbeiter Gesellen" },
    { type: "aushilfen", label: "Aushilfen" },
    { type: "azubi", label: "Auszubildende" },
  ];

  return (
    <VStack align="stretch" spacing={5} mt={8}>
      <Text fontWeight="bold" fontSize="lg">Anzahl der Mitarbeiter & Regelvergütung</Text>

      {rows.map((row) => (
        <HStack key={row.type} spacing={4}>
          {/* Anzahl */}
          <Input
            placeholder={`${row.label} Anzahl`}
            type="number"
            name={`${row.type}Count`}
            value={partnerRates[`${row.type}Count`] || ""}
            onChange={handleChange}
          />

          {/* Regelstundensatz */}
          <Input
            placeholder="Regelstundensatz €"
            type="number"
            name={`${row.type}Regelstunde`}
            value={partnerRates[`${row.type}Regelstunde`] || ""}
            onChange={handleChange}
          />

          {/* Nachtarbeit */}
          <Input
            placeholder="Nachtarbeit €"
            type="number"
            name={`${row.type}Nachtarbeit`}
            value={partnerRates[`${row.type}Nachtarbeit`] || ""}
            onChange={handleChange}
          />

          {/* Sonn-/Feiertag */}
          <Input
            placeholder="Sonn-/Feiertag €"
            type="number"
            name={`${row.type}SonnFeiertag`}
            value={partnerRates[`${row.type}SonnFeiertag`] || ""}
            onChange={handleChange}
          />

          {/* Fahrtkosten */}
          <Input
            placeholder="Fahrtkosten €/km"
            type="number"
            name={`${row.type}Fahrtkosten`}
            value={partnerRates[`${row.type}Fahrtkosten`] || ""}
            onChange={handleChange}
          />
        </HStack>
      ))}
    </VStack>
  );
}